<template>
    <div class="Footer">
        <div class="footer_logo"><img src="../assets/publicImg/footer/footer_logo.png" alt=""></div>
        <div class="footer_center">
            <!-- <p><span class='scroll_top' @click="scrollTop()">回到顶部</span></p>-->
            <ul class="end_link">
                <li v-for="(n,i) in footerList" :key="i" @click="endLink(i)">{{$t(n)}}</li>
            </ul>
            <ul class="img_lists">
                <li><a href="
https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa173a7392f915647&redirect_uri=http%3a%2f%2foauth.wx.xiao-bo.com%2fz_wx%2fa_oauth__callback.aspx%3fwx_state%3d0%257c6363728600189930521250%257cmall_ticket_b%2524group_id%253aabc-33fe1e04-3107-4f07-b672-64bb3fe16009&response_type=code&scope=snsapi_base&state=&component_appid=wx9818461f4a64b6df#wechat_redirect"><img
                        src="../assets/publicImg/footer/footer_1.png" alt=""></a></li>
                <li><a href="https://weibo.com/changlunongzhuang"><img src="../assets/publicImg/footer/footer_2.png"
                                                                       alt=""></a></li>
                <li>
                    <a href="https://fscllyxby.fliggy.com/search.htm?spm=a1z10.1-b.w5001-15605970548.3.13f73b97nw8AaQ&scene=taobao_shop"><img
                            src="../assets/publicImg/footer/footer_3.png" alt=""></a></li>
            </ul>
            <p>{{$t('service_tel')}}：0757-27331088</p>
            <p>{{$t('address')}}：{{$t('address_content')}}</p>
            <p><a href="http://www.miitbeian.gov.cn/">{{$t('G_case')}}14003973号-1</a><a
                    href="http://wljg.gdgs.gov.cn/corpsrch.aspx?key=440681000119502">{{$t('IC_case')}}P06811608002106</a></p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Footer",
        data: function () {
            return {
                clientHeight: '',
                footerList: ['footerNav[0]','footerNav[1]', 'footerNav[2]', 'footerNav[3]', 'footerNav[4]', 'footerNav[5]', 'footerNav[6]'],
                endCurrent: '-1',
            }
        },
        created: function () {
            this.clientHeight = `${document.documentElement.clientHeight}`;//屏幕可視高度
            // console.log(this.clientHeight);

        },
        methods: {
            scrollTop: function () {
                /* const srollPos = document.documentElement.scrollTop || document.body.scrollTop;//滾動的高度；*/
            },
            endLink(i) {
                this.$store.commit("set_current", '-1');
                switch (i) {
                    case 0:
                        this.$router.push({path: '/joinUs'});

                        break;
                    case 1:
                        this.$router.push({path: '/newsCenter'});
                        break;
                    case 2:
                        this.$router.push({path: '/contactUs'});
                        break;
                    case 3:
                        this.$router.push({path: '/aboutLong'});
                        break;
                    case 4:
                        this.$router.push({path: '/companyProfile'});
                        break;
                    case 5:
                        this.$router.push({path: '/link'});
                        break;
                    case 6:
                        this.$router.push({path: '/share'});
                        break;
                }

            }
        },
        computed: {
            //计算属性，
            current: function () {
                //先用变量接住我们存储在vuex里面的数据，
                return this.$store.state.home.current;
            }

        }
    }
</script>

<style scoped lang="less">
    @import "../assets/less/common";

    .Footer {
        width: @width;
        min-height: 160px;
        background: url(../assets/publicImg/footer/footer_bg.png) no-repeat;
        .box-sizing;
        background-size: cover;
        padding: 10px 15px 10px 15px;
        position: relative;
        @media (max-width: 360px) {
            height: 172px;

        }
        @media (max-width: 320px) {
            height: 176px;
            padding: 10px 10px 0 10px;
        }
        .footer_logo {
            position: absolute;
            top: 6%;
            left: 4%;
            width: 52px;
            height: 60px;
            img {
                width: @width;
            }
            @media(max-width: 320px){
                left:2%;
            }
        }
        .footer_center {
            color: @font-primary;
            font-size: .7rem;
            width: 80%;
            margin: auto;
            height: @width;
            text-align: center;
            p {
                margin-bottom: 4px;
                line-height: 16px;
                a:first-child {
                    margin-right: 7px;
                }
                @media (max-width: 320px) {
                    a {
                        display: block;
                        margin-bottom: 6px;
                    }
                }
              &:last-child {
                  margin-bottom: 0;
              }
            }
            a {
                color: @font-primary;
            }

            .end_link {
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
                align-items: center;
                width: 106%;
                margin: auto;
                font-size: 0.78rem;
               @media (min-width: 376px)and(max-width: 414px){
                   font-size: 0.9rem;
                   width: 103%;
               }
                @media (min-width: 415px )and (max-width: 455px){
                    font-size: 0.9rem;
                    width: 102%;
                }
                @media (max-width: 360px) {
                    width: 108%;
                }
                @media (max-width: 320px) {
                    width: 117%;
                    font-size: 0.6rem;
                }
                li {
                    border-right: 1px solid @font-primary;
                    padding: 0 10px;
                    margin-bottom: 10px;

                    &:last-child {
                        border-right: none;
                    }

                    @media(max-width: 767px){
                        &:nth-child(3) {
                            border-right: none;
                            margin-right: 10px;

                        }
                    }

                }

            }
            .img_lists {
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
                align-items: center;
                margin-bottom: 6px;
                li {
                    width: 30px;
                    margin-right: 8%;
                    a {

                        img {
                            .img
                        }
                    }
                    &:last-child {
                        margin-right: 0;
                    }
                }
            }

        }

    }

    @media (min-width: 768px)and (orientation: portrait) {
        .Footer {
            height: 170px;
            .footer_logo {
                width: 88px;
                left: 2%;
            }
            .footer_center {
                font-size: 1.2rem;
                width: 90%;
                p {
                    margin-bottom: 9px;
                    line-height: 16px;
                    &:last-child {
                        margin-bottom: 0;
                    }
                    a:first-child {
                        margin-right: 7px;
                    }
                    @media (max-width: 320px) {
                        a {
                            display: block;
                            margin-bottom: 6px;
                        }
                    }
                }
                a {
                    color: @font-primary;
                }

                .end_link {
                    font-size: 1rem;
                    @media(min-height: 1020px){
                        font-size: 1.2rem;
                    }
                    li {
                        border-right: 1px solid @font-primary;
                        padding: 0 10px;
                        margin-bottom: 10px;
                    }

                }
                .img_lists {
                    margin-bottom: 6px;
                    li {
                        width: 44px;
                        margin-right: 6%;
                        a {

                            img {
                                .img
                            }
                        }
                        &:last-child {
                            margin-right: 0;
                        }
                    }
                }

            }

        }
    }
</style>


